// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "1850" ? "monaco-editor" : chunkId) + "." + {"1850": "e56fa031","5491": "f2aa62d5","718": "95fe9399","8419": "65b828a6","8716": "8d2c846f",}[chunkId] + ".css"
}